export const iconFontAwesomeHumanitarianPills = (
	<i className="fa-solid fa-pills"></i>
);
